export default __webpack_public_path__ + "static/profile2-99787da2f72b8a8a99853ee01e2ecd47.png";